export interface IDateCalculateAssociatable {
  isHisInfo: boolean;
  name: string;
  groupKey: string;
  value: any;
}

export function instanceOfIDateCalculateAssociatable(instance: any): instance is IDateCalculateAssociatable {
  if (!instance) { return false; }
  return true;
}
